import { Component, OnInit } from '@angular/core';
import {Http} from '@angular/http';
import {  IMyDpOptions ,} from 'mydatepicker';
import { MyDatePickerModule} from 'mydatepicker';
import { CallBackEndService } from '../call-back-end.service';
import { IbRequest } from '../ib-request';
import { IbResponse } from '../ib-response';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { Angular2CsvModule } from 'angular2-csv';
declare var getHexAscii: any;
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
import * as jsPDF from 'jspdf';
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import 'rxjs/Rx';
import {DatePipe} from "@angular/common";
@Component({
  selector: 'app-td-statment-of-account',
  templateUrl: './td-statment-of-account.component.html',
  styleUrls: ['./td-statment-of-account.component.css'],
  providers: [
    { provide: 'Window', useValue: window },
    [DatePipe]
  ]
})
export class TdStatmentOfAccountComponent implements OnInit {
  http: any;
  //public data;

  public filterQuery = '';
  public rowsOnPage = 5;
  public sortBy = 'particulars';
  public sortOrder = 'asc';
  isShow1: string = ' ' ;
  isHaveLoanAccount: string;
  linkedAccounts: any;
  isShow: string = ' ';

  scoAccounts: any;
  scoAndLoanAccounts : any =[];
  loanAccounts : any = [];
  tdAccounts : any [];
  tdDetails: any;
  tdAccountHolderDetails: any =[];
  message: string;

  //tdStatementOfAccountList : any [];
  data: any [];
  sTaccountInfoTD: any;
  staccountNoTD: string;
  accountDigit :any ;
  isHaveTDAccount: string = '';
  fromDate : any;
  toDate : any;
  fromDate1 : any;
  toDate1 : any;
  tdacctNo :any="" ;
  address1 : string ;
  address2 : string ;
  totalDebit =0;// any ;
  totalCredit =0;//: any;
  totalAmount : any;
  crOrDr : any;
  space='  ';
  loanStatementOfAccountResp : any=[];
  loanAccountHolderDetails : any =[];
  excelOrPdfName : string ;
  tdStatementOfAccountResp : any=[];
  transactionListTD : any =[];
  recieptListTD : any =[];
  recieptsNo : string="";
  showTDAllTransaction: string='';
  showTDAcctBalance: string = '';
  showTDAcctBalanceButtonName: string ='';
  showTDAllTransactionButtonName: string ='';
  isTrueTD: string = 'show';
  isError:boolean=false;
  error:string="";
  mytime:Date = new Date();
  currentYear:any= this.mytime.getUTCFullYear();
  currentDate:any= this.mytime.getUTCDate()+1;
  currentMonth:any= this.mytime.getUTCMonth() + 1;
  currentMonth1:any= this.mytime.getUTCMonth() + 7;
  fromyear=this.mytime.getUTCFullYear()-2;  //Date disable 
  moduleType : string ='';
  fullName : string ='' ;
  clrBalanceStr : string ='';

  subBtnDisabled:boolean=false;
  fromDateNull : string ='';
  toDateNull : string='';
  messageForDate : string = '';
  messageForDate1 : string = '';
  messageForDate2 : string = '';
  fromGreaterCurrent : string ='';
  accountNull : string = '';
  statacct: string;
  formatedDate : string='';
  recieptNull : string ='';
  recieptnotFound : string ='';
  indNum : number=0;
  contactNo: any;
  constructor(private webService: CallBackEndService,
              private spinnerService: Ng4LoadingSpinnerService,
              private datePipe: DatePipe,


  ) {
    this.scoAccounts = JSON.parse(sessionStorage.getItem('scoAccounts'));
    this.scoAndLoanAccounts = JSON.parse(sessionStorage.getItem('scoAndLoanAccounts'));
    this.tdAccounts=JSON.parse(sessionStorage.getItem('tdAccounts'));
    this.tdAccounts = JSON.parse(sessionStorage.getItem('tdAccounts'));
    this.tdDetails = JSON.parse(sessionStorage.getItem('tdDetails'));
    this.linkedAccounts = JSON.parse(sessionStorage.getItem('linkedAccounts'));
    this.isHaveLoanAccount =sessionStorage.getItem('isHaveLoanAccount');
    this.isHaveTDAccount =sessionStorage.getItem('isHaveTDAccount');
    const request: IbRequest = new IbRequest();
    const response: IbResponse = null;
    this.staccountNoTD=this.tdAccounts[0];

    request.param1 = getHexAscii('', this.staccountNoTD);



    request.param2 = this.staccountNoTD;
    if(this.staccountNoTD === undefined ){
      this.isShow='RecordNotFound';
      this.message="Record Not Found";
    }
    //this.isTrueTD='hide';
    else {
      this.webService.getResponse(request, 'miniTransactionList').subscribe((data: IbResponse) => {
        console.log("status isss " + data.status + "param 8 isss " + data.param8);
        this.showTDAcctBalance = 'hide';
        this.showTDAllTransaction = 'hide';
        if (data.status === 'S101') {
          alert('Malicious Request Detected');
          // $state.go('login');
        }
        if (data !== null && data.status === 'S200') {
          //this.transactionListRespTD=IbResponse;
          this.showTDAllTransaction = 'hide';
          console.log("come here");

          this.sTaccountInfoTD = data.param5;
          this.transactionListTD = data.param8;
          this.moduleType = data.param5.moduleType;
          this.fullName = data.param5.fullName;
          this.clrBalanceStr = data.param5.clrBalanceStr;
          //this.recieptsNo=this.transactionListTD.recieptNo;
          //console.log("this.recieptsNo isss "+this.recieptsNo);
          this.isShow = 'page2';
          console.log("data isss " + data);
          //this.isTrueTD='show';
        }
        this.isTrueTD = 'show';
      });
    }

  }

  ngOnInit(){
   

    this.formatedDate = this.datePipe.transform(new Date(), 'dd-MMM-yyyy');
    }
  public toInt(num: string) {
    return +num;
  }

  public sortByWordLength = (a: any) => {
    return a.city.length;
  }

  myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd-mm-yyyy',
    editableDateField:false,
	//disableUntil:{year: this.fromyear, month: this.currentMonth, day: this.currentDate},
	 disableUntil:{year: this.fromyear, month: this.currentMonth, day: this.currentDate-2},
     disableSince:{year: this.currentYear, month: this.currentMonth, day: this.currentDate},
  };
  myDatePickerOptions1: IMyDpOptions = {
    dateFormat: 'dd-mm-yyyy',
    editableDateField:false,
    disableSince:{year: this.currentYear, month: this.currentMonth, day: this.currentDate},
  };

  removeDateError(){
    console.log('click on date called:');
    this.subBtnDisabled=false;
  }
  tdStatementOfAccount()
  {
    const request: IbRequest = new IbRequest();
    let response: IbResponse = null;
    this.spinnerService.show();
    this.subBtnDisabled = true;
    this.accountNull = '';
    this.fromDateNull = '';
    this.toDateNull = '';
    //this.isLoad = true;
    if (this.tdacctNo === '' || this.tdacctNo === undefined || this.tdacctNo === null) {
      this.accountNull = 'no';
      this.spinnerService.hide();
      this.subBtnDisabled = false;
    }
  //  else if (this.recieptsNo === '' || this.recieptsNo === undefined || this.recieptsNo === null) {
  //     this.recieptNull = 'no';
  //     this.spinnerService.hide();
  //     this.subBtnDisabled = false;
  //   }
    else if (this.fromDate === '' || this.fromDate === undefined || this.fromDate === null) {
      this.fromDateNull = 'no';
      this.subBtnDisabled = false;
      this.spinnerService.hide();
    } else if (this.toDate === '' || this.toDate === undefined || this.toDate === null) {
      this.toDateNull = 'no';
      this.subBtnDisabled = false;
      this.spinnerService.hide();
    } else {

      this.messageForDate = '';
      this.messageForDate1 = '';
      this.messageForDate2 = '';
      this.fromGreaterCurrent = '';
      var date1 = (this.fromDate.date.day + "-" + this.dateconvert(this.fromDate.date.month) + "-" + this.fromDate.date.year).split("-");
      var date2 = (this.toDate.date.day + "-" + this.dateconvert(this.toDate.date.month) + "-" + this.toDate.date.year).split("-");
      var date3 = this.formatedDate.split("-");
      console.log('all dates : '+date1+' ,'+date2+' ,'+date3);
      var d1 = Date.parse(date1[0] + "-" + date1[1] + "-" + date1[2]);
      var d2 = Date.parse(date2[0] + "-" + date2[1] + "-" + date2[2]);
      var d3 = Date.parse(date3[0] + "-" + date3[1] + "-" + date3[2]);
      console.log('all d : '+d1+' ,'+d2+' ,'+d3);

      if (d1 > d2) {
        this.messageForDate = 'no';
        this.subBtnDisabled = false;
        this.spinnerService.hide();
      } else if (d2 > d3) {
        this.messageForDate1 = 'no';
        this.subBtnDisabled = false;
        this.spinnerService.hide();
      } else if (d1 > d3) {
        this.fromGreaterCurrent = 'no';
        this.subBtnDisabled = false;
        this.spinnerService.hide();
      } else {

      
        this.accountDigit = this.scoAccounts[0];
        console.log("sco account iss " + this.accountDigit);

        const frm = JSON.stringify(this.fromDate);
        console.log("frm date " + this.fromDate.formatted + "");
        console.log("frm year " + this.fromDate.date.year + "");
        console.log("frm month " + this.fromDate.date.month + "");
        console.log("frm day " + this.fromDate.date.day + "");
        request.param4 = this.fromDate.date.day + "-" + this.getMonthName(this.fromDate.date.month) + "-" + this.fromDate.date.year;
        request.param5 = this.toDate.date.day + "-" + this.getMonthName(this.toDate.date.month) + "-" + this.toDate.date.year;
       const Details: any = {
        'userName':sessionStorage.getItem('storedUserName')
      
      };
        request.param6=Details;
        request.param1 = getHexAscii('', this.tdacctNo + this.recieptsNo + request.param4 + request.param5+sessionStorage.getItem('storedUserName'));
        //request.param2=sessionStorage.getItem('storedUserName');
        //request.param2 = this.accountDigit;
        request.param2 = this.tdacctNo;
        request.param3 = this.recieptsNo;

        //     request.param3=this.fromDate.formatted+"";
        // request.param4 =this.toDate.formatted+"";

        console.log("from date  " + this.fromDate + "to date  " + this.fromDate);
        this.webService.getResponse(request, 'tdAccountStatement').subscribe((data: IbResponse) => { 
         
          // this.tdAccountHolderDetails = data.param5;
          // this.data = data.param6;
          // console.log('ddfdf' + data.status);
          if (data !== null &&(data.status === 'OBJECT_NOT_FOUND' )) {
            console.log('record null p6 len : '+data.param6.length);
            this.error = data.statusDescription;
            this.isError = true;
            this.subBtnDisabled=false;
            this.isShow1 = '';
            this.spinnerService.hide();
          }
          // else if( this.data==null || this.data==undefined || this.data.length==0){
          //   console.log('param 6 is null');
          //   this.error = 'Record Not Found';//param 6 is null
          //   this.isError = true;
          //   this.subBtnDisabled=false;
          //   this.isShow1 = '';
          //   this.spinnerService.hide();
          // } 
          else if (data.status === 'S101') {
            this.spinnerService.hide();
            alert('Malicious Request Detected');
            //this.isLoad = false;
            this.isError = true;

          }else if(data !== null && data.status !=='S200'){
            this.error = data.statusDescription;
            this.isError = true;
            this.subBtnDisabled=false;
            this.isShow1 = '';
            this.spinnerService.hide();
          } else {
            this.tdAccountHolderDetails = data.param5;
            this.data = data.param6;
            if( this.data==null || this.data==undefined || this.data.length==0){
              console.log('param 6 is null');
              this.error = 'Record Not Found';//param 6 is null
              this.isError = true;
              this.subBtnDisabled=false;
              this.isShow1 = '';
              this.spinnerService.hide();
              return;
            }
            console.log('ddfdf' + data.status);

            this.excelOrPdfName = this.tdAccountHolderDetails.accountNo15Digit + '_' + this.tdAccountHolderDetails.todayDate;
            if( this.tdAccountHolderDetails.add1!=null && this.tdAccountHolderDetails.add1!=undefined && this.tdAccountHolderDetails.add1!==''){
              this.address1 = this.tdAccountHolderDetails.add1 + ', ';
            }
            if( this.tdAccountHolderDetails.add2!=null && this.tdAccountHolderDetails.add2!=undefined && this.tdAccountHolderDetails.add2!==''){
              this.address1 =  this.address1 +this.tdAccountHolderDetails.add2 + ', ';
            }
            if( this.tdAccountHolderDetails.add3!=null && this.tdAccountHolderDetails.add3!=undefined && this.tdAccountHolderDetails.add3!==''){
              this.address1 = this.address1 + this.tdAccountHolderDetails.add3 + ', ';
            }
           // this.address1 = this.tdAccountHolderDetails.add1 + ',' + this.tdAccountHolderDetails.add2 + ',' + this.tdAccountHolderDetails.add3;
           // this.address2 = this.tdAccountHolderDetails.areaDesc + ',' + this.tdAccountHolderDetails.phoneNo + ',' + this.tdAccountHolderDetails.cityDesc + ',' + this.tdAccountHolderDetails.pinCd;
            this.address2 = this.tdAccountHolderDetails.areaDesc + ',' + this.tdAccountHolderDetails.cityDesc + ',' + this.tdAccountHolderDetails.pinCd;       
            //data = this.tdStatementOfAccountResp;
            this.isError = false;
            this.error='';
            this.isShow1 = 'page2';

            for (var v of this.data){
              console.log('param6 obj : '+v);
              console.log('param6 obj : '+v.balance);
            }
            for (const [key, value] of Object.entries(this.data)) {
              console.log('value ; ---'+value);
              if (value.drCr === 'D') {
                this.totalDebit = Number(this.totalDebit) + Number(value.fcyTrnAmt || 0);
                console.log('this.totalDebit --'+this.totalDebit+'   value.fcyTrnAmt  '+value.fcyTrnAmt);
                this.crOrDr = 'DR';
              }
              if (value.drCr === 'C') {
                console.log('this.totalCredit1 --'+Number(this.totalCredit)+'   value.fcyTrnAmt  '+value.fcyTrnAmt);
                this.totalCredit = Number(this.totalCredit) + Number(value.fcyTrnAmt || 0);
                console.log('this.totalCredit --'+this.totalCredit+'   value.fcyTrnAmt  '+value.fcyTrnAmt);
                this.crOrDr = 'CR';
              }
              this.totalAmount = value.balance;
               console.log('bal     : '+value.balance);

            }
           // if (data !== null && data.status === 'S200') {
              this.isShow1 = 'page2';
              console.log('page2' + this.isShow1);
              this.spinnerService.hide();
              this.isError = true;
              this.subBtnDisabled = false;
              //this.error = response.statusDescription;


           // } 
          }
        });
      }
      }
  }

  showTransactionTD() {
    const request: IbRequest = new IbRequest();
    const response: IbResponse = null;
    console.log("td account iss "+this.staccountNoTD);
    request.param1 = getHexAscii('', this.staccountNoTD);
    request.param2 = this.staccountNoTD;
    //this.isTrueTD='hide';
    this.webService.getResponse(request, 'miniTransactionList').subscribe((data: IbResponse) => {
      console.log("status isss "+data.status+"param 8 isss "+data.param8);
      this.showTDAcctBalance='hide';
      this.showTDAllTransaction='hide';
      if (data.status === 'S101') {
        alert('Malicious Request Detected');
        // $state.go('login');
      }
      if (data !== null && data.status === 'S200') {
        //this.transactionListRespTD=IbResponse;
        this.showTDAllTransaction='hide';
        console.log("come here");

        this.sTaccountInfoTD=data.param5;

       // this.transactionListTD = data.param8;
        this.moduleType = data.param5.moduleType;
        this.fullName = data.param5.fullName;
        this.clrBalanceStr = data.param5.clrBalanceStr;
        console.log("dvgg"+JSON.stringify(this.sTaccountInfoTD));
        this.transactionListTD=data.param8;
        console.log("dvgg3333"+JSON.stringify(data.param8));
        //this.recieptsNo=this.transactionListTD.recieptNo;
        this.isShow='page2';
        console.log("data isss "+data);
        //this.isTrueTD='show';
      }
      this.isTrueTD='show';
    });
  }
  getReciepts()
  {
    this.recieptListTD=[];
    this.spinnerService.show();
    const request: IbRequest = new IbRequest();
    let response: IbResponse = null;
    request.param1=getHexAscii("",this.tdacctNo),
      request.param2=this.tdacctNo;
      

    this.webService.getResponse(request, 'getRecieptsOfTDAccount').subscribe((data: IbResponse) => {
      console.log("status isss "+data.status+"param 8 isss "+data.param8+"stringfy val isss "+JSON.stringify(data.param8));
      this.spinnerService.hide();
      if (data.status === 'S101'){
        alert('Malicious Request Detected');
        // $state.go('login');
      }
      if(data !== null && data.status === 'OBJECT_NOT_FOUND')
      {
        this.isError = true;
       this.recieptnotFound='no';
       // this.error = data.statusDescription;

      }
     else if (data !== null && data.status === 'S200') {
        //this.transactionListRespTD=IbResponse;
        for (const [key, value] of Object.entries(data.param8)) {
          this.recieptListTD.push(value.recieptNo);

        }
      }else{
        this.isError = true;
       this.error=data.param1;
      }
      //  else if (data !== null && data.status === 'S200') {
      //   //this.error = response.statusDescription;
      // }
      console.log("tdvalue isss "+this.recieptListTD);
    });
  }
  downloadPdf() {

    var pdf = new jsPDF();
    var a = Number(20 || 0);
    var b = Number(5 || 0);
    var c = Number(30 || 0);
    var d = Number(20 || 0);
    var e = Number(179 || 0);
    var f = Number(40 || 0);
    var g = Number(3 || 0);
    var h = Number(2 || 0);
    var i = Number(1 || 0);
   //this.totalDebit = Number(0 || 0);
    //this.totalCredit = Number(0 || 0);
    //this.totalAmount = Number(0 || 0);
    //this.crOrDr='';
    pdf.setFontSize(6);
    pdf.text(h+2, a, ''); pdf.text(h+108, a, '');a=a+b; d=d+b; //blank line
    pdf.text(h+2, a, ''); pdf.text(h+108, a, '');a=a+b; d=d+b;
    // pdf.text(h+2, a, 'TD Account No : '+this.tdAccountHolderDetails.recieptNo); pdf.text(h+108, a, 'Branch IFSC Code : '+this.tdAccountHolderDetails.branchIfscCd);a=a+b; d=d+b;
    pdf.text(h+2, a, 'TD Account No : '); pdf.text(25,a,this.tdAccountHolderDetails.accountNo15Digit); pdf.text(h+108, a, 'Branch IFSC Code : '+this.tdAccountHolderDetails.branchIfscCd);a=a+b; d=d+b;
    pdf.text(h+2, a, 'Name : '); pdf.text(25,a,this.tdAccountHolderDetails.name+''); pdf.text(h+108, a, 'Branch MICR Code : '+this.tdAccountHolderDetails.micrCode); a=a+b; d=d+b;
    pdf.text(h+2, a, 'Address : '); pdf.text(25, a, this.address1); a=a+g; d=d+g;
    pdf.text(25, a, this.address2); a=a+b; d=d+b;
    pdf.text(h+2, a, 'Contact Number : '); pdf.text(25, a, this.tdAccountHolderDetails.phoneNo); a=a+g; d=d+g;                   
    pdf.text(h+2, a, 'Joint Names 1 : '); pdf.text(25, a,this.tdAccountHolderDetails.firstJointHolder); pdf.text(h+108, a, 'Joint Names 2 : '+this.tdAccountHolderDetails.secondeJointHolder);a=a+b; d=d+b;
    pdf.text(h+2, a, 'Opening Date : '); pdf.text(25, a,this.tdAccountHolderDetails.asOffDate);pdf.text(h+108, a, 'Maturity Date  : '+this.tdAccountHolderDetails.matDate);a=a+b; d=d+b;
    pdf.text(h+2, a, 'Maturity Amount : '); pdf.text(25, a,this.tdAccountHolderDetails.matVal);pdf.text(h+108, a, 'Period : Days : '+this.tdAccountHolderDetails.noOfDays+' Months : '+this.tdAccountHolderDetails.noOfMonths);a=a+b; d=d+b;
    pdf.text(h+2, a, 'Intrest Rate : '); pdf.text(25, a,this.tdAccountHolderDetails.intRate);pdf.text(h+108, a, 'Lien Amount : '+this.tdAccountHolderDetails.totalLien);a=a+b; d=d+b;
    pdf.text(h+2, a, 'Period : '); pdf.text(25, a,this.tdAccountHolderDetails.period+'');a=a+b; d=d+b;
    c=d+5;
    pdf.line(2, a-3, e, a-3);
    for(const [key, value] of Object.entries(this.data)) {
      if(i===1){
        pdf.setFontType("bolditalic"); 
        pdf.setTextColor(0, 0, 255);

        pdf.text(h, a, 'SR. No.');
        pdf.text(h+8, a, 'Date');
        pdf.text(h+38, a, 'Particulars');
        pdf.text(h+123, a, 'Dr Amount');
        pdf.text(h+138, a, 'Cr Amount');
        pdf.text(h+153, a, 'Total Amount');
        pdf.text(h+170, a, 'DR/CR');

        pdf.setTextColor(100);
      }
      i++;
      a=a+b;
      c=c+5;
      pdf.line(2, a-3, e, a-3);

      if((i-1)%f===0){
        pdf.setFontType("bolditalic");
        pdf.setTextColor(0, 0, 255);

        pdf.text(h, a, 'SR. No.');
        pdf.text(h+8, a, 'Date');
        pdf.text(h+38, a, 'Particulars');
        pdf.text(h+123, a, 'Dr Amount');
        pdf.text(h+138, a, 'Cr Amount');
        pdf.text(h+153, a, 'Total Amount');
        pdf.text(h+170, a, 'DR/CR');

        pdf.setTextColor(100);
        a=a+b;
        c=c+5;
        i++;
        pdf.line(2, a-3, e, a-3);
        this.indNum=Number(key)+1 ;
        pdf.text(h+3, a, (this.indNum)+'');
        pdf.text(h+8, a, value.postDate+'');
        pdf.text(h+26, a, value.particulars+'');
        if(value.drCr==='D'){
          pdf.text(h+123, a, value.fcyTrnAmt+'');
          pdf.text(h+168, a, 'DR');
          /*totalDrAmount=totalDrAmount+Number(value.fcyTrnAmt || 0);
          crDr='DR';*/
        }
        if(value.drCr==='C'){
          pdf.text(h+123, a, value.fcyTrnAmt+'');
          pdf.text(h+168, a, 'CR');
          /*totalCrAmount=totalCrAmount+Number(value.fcyTrnAmt || 0);
          crDr='CR';*/
        }
        pdf.text(h+153, a, value.balance+'');

      }else{
        this.indNum=Number(key)+1 ;
        pdf.text(h+3, a, (this.indNum)+'');
        pdf.text(h+8, a, value.postDate+'');
        pdf.text(h+26, a, value.particulars+'');
        if(value.drCr==='D'){
          pdf.text(h+123, a, value.fcyTrnAmt+'');
          pdf.text(h+170, a, 'DR');
          /*totalDrAmount=totalDrAmount+Number(value.fcyTrnAmt || 0);
          crDr='DR';*/
        }
        if(value.drCr==='C'){
          pdf.text(h+138, a, value.fcyTrnAmt+'');
          pdf.text(h+170, a, 'CR');
          /*totalCrAmount=totalCrAmount+Number(value.fcyTrnAmt || 0);
          crDr='CR';*/
        }
        pdf.text(h+153, a, value.balance+'');
      }
      //totalClosingAmount = value.balance;
      if(i%f===0){
        pdf.line(h, d-3, h, c-3);
        pdf.line(h+7, d-3, h+7, c-3);
        pdf.line(h+25, d-3, h+25, c-3);
        pdf.line(h+122, d-3, h+122, c-3);
        pdf.line(h+137, d-3, h+137, c-3);
        pdf.line(h+152, d-3, h+152, c-3);
        pdf.line(h+167, d-3, h+167, c-3);
        pdf.line(h+177, d-3, h+177, c-3);

        pdf.line(h, a+2, e, a+2);

        pdf.addPage();
        a=20;
        d=25;
        c=25;
      }
    }

    pdf.line(h, d-3, 2, c-3);
    pdf.line(h+7, d-3, h+7, c-3);
    pdf.line(h+25, d-3, h+25, c-3);
    pdf.line(h+122, d-3, h+122, c-3);
    pdf.line(h+137, d-3, h+137, c-3);
    pdf.line(h+152, d-3, h+152, c-3);
    pdf.line(h+167, d-3, h+167, c-3);
    pdf.line(h+177, d-3, h+177, c-3);

    pdf.line(h, a-3, e, a-3);

    a=a+b;
    pdf.text(h, a, 'Totals / Balance :-');
    pdf.text(h+123, a, this.totalDebit+'');
    pdf.text(h+138, a, this.totalCredit+'');
    pdf.text(h+153, a, this.totalAmount+'');
    pdf.text(h+168, a, this.crOrDr);

    pdf.line(2, a-3, e, a-3);

    a=a+b;
    pdf.text(h, a, 'Closing Balance:-');
    pdf.text(h+153, a, this.totalAmount+'');
    pdf.line(h, a-3, e, a-3);

    a=a+b;
    pdf.line(h, a-3, e, a-3);

    var img = new Image;
    img.onload = function() {
      pdf.setPage(1);
      pdf.addImage(this, 2, 5, 100, 17);
      pdf.save("TDstatment"+".pdf");
      console.log("hi9iiiii");
    };
    img.crossOrigin = "";
    img.src = 'assets/img/LogoWithName.png'; //'assets/img/LogoWithName.png';

  }//-------------------------------------------------------------------------

  downloadcsv(){
    var csvData = this.ConvertToCSV(this.data);
    var a = document.createElement("a");
    a.setAttribute('style', 'display:none;');
    document.body.appendChild(a);
    var blob = new Blob([csvData], { type: 'text/csv' });
    var url= window.URL.createObjectURL(blob);
    a.href = url;
    a.download = 'TDStatment.csv';
    a.click();
  }
  ConvertToCSV(objArray) {
    var array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
    var str = '';
    var row = "";

    for (var index in objArray[0]) {
      //Now convert each value to string and comma-separated
      row += index + ',';
    }
    row = row.slice(0, -1);
    //append Label row with line break
    str += row + '\r\n';

    for (var i = 0; i < array.length; i++) {
      var line = '';
      for (var index in array[i]) {
        if (line !== ''){ line += ',';}

        line += array[i][index];
      }
      str += line + '\r\n';
    }
    return str;
  }
  getMonthName(month)
  {
    return ["Jan","Feb","Mar","Apr","May","June","Jul","Aug","Sep", "Oct","Nov","Dec"][Number(month)-1];
  }
  dateconvert(monthNumber) { //1 = January
    var monthNames = [ 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'June',
      'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec' ];
    return monthNames[monthNumber - 1];
  }
  removestacctMessage()
  {
    this.accountNull='';
    this.recieptnotFound='';
  }
  removeRecieptMessage()
  {
    this.recieptNull='';
  }
}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/td-statment-of-account/td-statment-of-account.component.ts